<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="9">
        <b-form @reload="reload" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model="form.keyword"
              :placeholder="
                $l('tips_purchase_fabric_search') ||
                  '采购单号/订单号/供应商搜...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <div class="drop" v-if="allow('I')">
              <el-dropdown
                size="small"
                split-button
                @click="handleImport('1')"
                @command="importTemplate"
                class="ml-2"
                :disabled="importLoading"
              >
                <i v-if="importLoading" class="el-icon-loading"></i>
                <b-icon v-else icon="cloud-upload" />
                {{ $l('btn_orderImport') || 'NC采购单导入' }}
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :disabled="importLoading">
                    {{ $l('tips_dropdownTemplate') || '下载 面料采购订单模板' }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="drop" v-if="allow('I')">
              <el-dropdown
                size="small"
                split-button
                @click="handleImport('2')"
                @command="outsourcedImportTemplate"
                class="ml-2"
                :disabled="outsourcedImportLoading"
              >
                <i v-if="outsourcedImportLoading" class="el-icon-loading"></i>
                <b-icon v-else icon="cloud-upload" />
                {{ $l('btn_outsourcedOrderImport') || '委外采购单导入' }}
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :disabled="outsourcedImportLoading">
                    {{ $l('tips_outsourcedDropdownTemplate') || '下载 委外采购订单模板' }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="drop" v-if="allow('BI')">
              <el-dropdown
                size="small"
                split-button
                @click="$emit('batchImport')"
                @command="batchImportDownload()"
                class="ml-2"
              >
                <b-icon icon="cloud-upload" />
                {{ $l('btn_batchImport') || 'NC采购单批量导入' }}
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    {{
                      $l('btn_batchImport_download') ||
                        '下载 面料采购批量订单模板'
                    }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </b-input-group>
        </b-form>
      </b-col>

      <el-dialog
        :title="$l('INDEX.advanced_search') || '高级搜索'"
        :show-close="true"
        :visible.sync="advqueryDialogVisible"
        width="750px"
        :close-on-click-modal="false"
      >
        <el-form
          ref="form"
          :model="form"
          label-position="right"
          label-width="130px"
          size="small"
        >
          <el-row :gutter="10">
            <el-col :span="24">
              <el-col :span="24">
                <el-form-item
                  :label="$l('form_label_purchaseStatus') || '单据状态'"
                >
                  <dict-check-box
                    :checkList="form.purchaseStatusList"
                    @change="handlePurchaseStatusChange"
                    size="small"
                    url="/sys/common/dict/system"
                    :body="{ dictType: 'purchaseStatus' }"
                  ></dict-check-box>
                </el-form-item>
              </el-col>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_purchaseFabricNo') || '采购单号'"
              >
                <el-input
                  v-model.trim="form.purchaseFabricNo"
                  clearable
                  size="small"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="
                  $l('INDEX.order_form_label_originOrderNo') || '源头订单号'
                "
              >
                <el-input
                  v-model.trim="form.originOrderNo"
                  clearable
                  size="small"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item :label="$l('INDEX.form_label_scmName') || '供方'">
                <dict-select
                  :placeholder="
                    $l('INDEX.tips_purchase_form_label_scmCode') ||
                      '请选择大货供应商'
                  "
                  size="small"
                  clearable
                  filterable
                  multiple
                  v-model="form.scmCodeList"
                  url="/master/common/dict/scmPartners"
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gitter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_purchaserEntityCode') || '需方'"
              >
                <dict-select
                  v-model="form.purchaserEntityCodeList"
                  url="/master/common/dict/biz"
                  :body="{ dictType: 'orderSource' }"
                  :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                  size="small"
                  style="width: 100%"
                  filterable
                  clearable
                  multiple
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gitter="10">
            <el-col :span="24">
              <el-form-item :label="$l('form_label_buyerName') || '采购人员'">
                <dict-select
                  multiple
                  clearable
                  v-model="form.buyerCodeList"
                  filterable
                  size="small"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('INDEX.form_label_please_select_a_buyer') ||
                      '请选择采购人员'
                  "
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gitter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_reviewByName') || '审核人员'"
              >
                <dict-select
                  multiple
                  clearable
                  v-model="form.reviewByList"
                  filterable
                  size="small"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('INDEX.form_label_please_select_a_review_by') ||
                      '请选择审核人员'
                  "
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gitter="10">
            <el-col :span="24">
              <el-form-item :label="$l('form_label_remark') || '备注说明'">
                <el-input v-model.trim="form.remark" clearable size="small">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_purchaseDate') || '制单日期'"
              >
                <el-row>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.beginPurchaseDate"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">--</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.endPurchaseDate"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item :label="$l('form_label_reviewTime') || '审核日期'">
                <el-row>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.beginReviewTime"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">--</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.endReviewTime"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item :label="$l('INDEX.create_date') || '创建时间'">
                <el-row>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.beginCreateTime"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">--</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.endCreateTime"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('INDEX.table_label_modification_date') || '修改时间'"
              >
                <el-row>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.beginModifyTime"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">--</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.endModifyTime"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gitter="10">
            <el-col :span="24">
              <el-form-item :label="$l('form_label_createBy') || '创建人'">
                <dict-select
                  multiple
                  clearable
                  v-model="form.createByList"
                  filterable
                  size="small"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('INDEX.form_label_please_select_a_create_by') ||
                      '请选择创建人'
                  "
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gitter="10">
            <el-col :span="24">
              <el-form-item :label="$l('form_label_modifyBy') || '修改人'">
                <dict-select
                  multiple
                  clearable
                  v-model="form.modifyByList"
                  filterable
                  size="small"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('INDEX.form_label_please_select_a_modify_by') ||
                      '请选择修改人'
                  "
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeAdvqueryDialog">
            {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
          </el-button>
          <el-button size="small" type="warning" @click="reload">
            {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
          </el-button>
          <el-button size="small" type="primary" @click="advquery">
            {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
          </el-button>
        </span>
      </el-dialog>
    </b-row>

    <ChooseImportTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
    />
  </div>
</template>

<script>
import { VXETable } from 'vxe-table'
import ChooseImportTemplate from '@/views/factory/components/choose-import-template'
import DictCheckBox from '@/views/factory/components/dict-check-box'

const initForm = { keyword: '', purchaseStatusList: ['N', 'Y'] }

export default {
  components: { ChooseImportTemplate, DictCheckBox },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      chooseTemplateOptions: { visible: false },
      importLoading: false,
      outsourcedImportLoading: false,
    }
  },
  created() {
    this.query()
  },
  methods: {
    //处理单据状态变化
    handlePurchaseStatusChange(val) {
      this.form.purchaseStatusList = val
    },
    //初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reload')
      }
      this.$emit('query', this.form)
    },
    //高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    //重置条件查询
    reload() {
      this.form = { ...initForm }
    },
    //打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    //关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    //导入文件
    async handleImport(type) {
      try {
        const { file } = await VXETable.readFile({
          types: ['csv', 'CSV', 'xls', 'xlsx', 'XLSX'],
        }).catch(() => ({}))

        if (!file) return

        // 用户选择了文件后才开始显示loading
        if (type === '1') {
          this.importLoading = true
        } else if (type === '2') {
          this.outsourcedImportLoading = true
        }

        // 先上传文件获取 fileUrl
        const uploadRes = await this.$api.SYS_UPLOAD(file).catch(() => null)
        if (!uploadRes || !uploadRes.body || !uploadRes.body.url) {
          this.$message.error(
            this.$l('INDEX.tips_upload_fail') || '文件上传失败！',
          )
          if (type === '1') {
            this.importLoading = false
          } else if (type === '2') {
            this.outsourcedImportLoading = false
          }
          return
        }

        const fileUrl = uploadRes.body.url

        // 调用导入接口
        await this.callImportApi(fileUrl, type, false)
      } catch (error) {
        console.error('导入失败:', error)
        this.$message.error(this.$l('INDEX.tips_import_no') || '导入失败！')
        if (type === '1') {
          this.importLoading = false
        } else if (type === '2') {
          this.outsourcedImportLoading = false
        }
      }
    },

    // 调用导入接口的核心方法
    async callImportApi(fileUrl, type, isUpdate = false) {
      try {
        if (type === '1') {
          this.importLoading = true
        } else if (type === '2') {
          this.outsourcedImportLoading = true
        }

        const importRes = await this.$api
          .purchaseFabricImportDataApi({
            url: fileUrl,
            isUpdate,
            type
          })
          .catch(() => null)

        if (!importRes) {
          this.$message.error(this.$l('INDEX.tips_import_no') || '导入失败！')
          if (type === '1') {
            this.importLoading = false
          } else if (type === '2') {
            this.outsourcedImportLoading = false
          }
          return
        }

        const { status, msg } = importRes

        // 如果返回 203，需要二次确认
        if (status === 203) {
          if (type === '1') {
            this.importLoading = false
          } else if (type === '2') {
            this.outsourcedImportLoading = false
          }
          this.$confirm(msg, '提示', {
            confirmButtonText: '是',
            cancelButtonText: '否',
            type: 'warning',
          })
            .then(() => {
              // 用户点击"是"，重新调用导入接口，传递 isUpdate=true
              this.callImportApi(fileUrl, type, true)
            })
            .catch(() => {
              // 用户点击"否"，不做任何操作
              this.$message({
                type: 'info',
                message: '已取消导入',
              })
            })
          return
        }

        if (status !== 200) {
          this.$message.error(
            msg || this.$l('INDEX.tips_import_no') || '导入失败！',
          )
          if (type === '1') {
            this.importLoading = false
          } else if (type === '2') {
            this.outsourcedImportLoading = false
          }
          return
        }

        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_import_ok') || '导入成功！',
          type: 'success',
        })

        // 刷新数据
        this.query()
        if (type === '1') {
          this.importLoading = false
        } else if (type === '2') {
          this.outsourcedImportLoading = false
        }
      } catch (error) {
        console.error('导入接口调用失败:', error)
        this.$message.error(this.$l('INDEX.tips_import_no') || '导入失败！')
        if (type === '1') {
          this.importLoading = false
        } else if (type === '2') {
          this.outsourcedImportLoading = false
        }
      }
    },
    //下载模板
    importTemplate() {
      this.chooseTemplateOptions = {
        visible: true,
        templateGroup: 'nc-purchase-fabric-group',
      }
    },
    outsourcedImportTemplate() {
      this.chooseTemplateOptions = {
        visible: true,
        templateGroup: 'out-purchase-fabric-group',
      }
    },
    batchImportDownload() {
      this.chooseTemplateOptions = {
        visible: true,
        templateGroup: 'nc-purchase-fabric-batch-group',
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
::v-deep {
  .drop {
    .el-button {
      border: 1px solid #28a745;
      color: #28a745;
      font-size: 0.875rem;
      border-radius: 3px 0px 0px 3px !important;
    }
    .el-dropdown__caret-button {
      border-left: none;
      border-radius: 0px 3px 3px 0px !important;
    }
    .el-button:hover {
      color: #fff;
      background-color: #28a745;
      border-color: #28a745;
    }
    .el-button--default::before {
      background: #d0d2d6;
    }
    .el-button--small {
      padding: 0.25rem 0.5rem;
      font-size: 0.875rem;
      line-height: 1.5;
    }
  }
}
</style>
